// @flow
import styled from '@emotion/styled'
import * as React from 'react'

import { ErrorWrapper } from './styles'

type FormProps = {
  className?: string,
  children: React.Node[],
  error?: React.Node,
  id?: string,
  action?: string,
  onSubmit: (e: SyntheticEvent<>) => void,
}

export const Form = ({
  children,
  error,
  onSubmit,
  className,
  ...props
}: FormProps) => {
  return (
    <StyledForm onSubmit={onSubmit} className={className} {...props}>
      {error && <ErrorWrapper>{error}</ErrorWrapper>}
      {children}
    </StyledForm>
  )
}

const StyledForm: React.ComponentType<any> = styled.form`
  input,
  select {
    width: 100%;
  }

  button {
    margin-top: 30px;
    width: 100%;
    justify-content: center;
  }
`
